import { render, staticRenderFns } from "./RFIDSettings.vue?vue&type=template&id=46f10fab"
import script from "./RFIDSettings.vue?vue&type=script&lang=js"
export * from "./RFIDSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports